import React from 'react';
import { Stack, Link, ComboBox, IComboBoxOption } from '@fluentui/react';
import { ChecklistData } from '../types';
import LabeledTextField from '../common/LabeledTextField';
import IvicosStrings from 'kits/language/stringKit';

const browsers: IComboBoxOption[] = [
    { key: 'chrome', text: 'Google Chrome' },
    { key: 'firefox', text: 'Mozilla Firefox' },
    { key: 'edge', text: 'Microsoft Edge' },
    { key: 'brave', text: 'Brave' },
    { key: IvicosStrings.webRTCDiagnosticsBrowserOther, text: IvicosStrings.webRTCDiagnosticsBrowserOther }
];

const yesNo: IComboBoxOption[] = [
    { key: IvicosStrings.yesAction, text: IvicosStrings.yesAction },
    { key: IvicosStrings.noAction, text: IvicosStrings.noAction }
];

interface Props {
    checklistData: ChecklistData;
    setChecklistData: React.Dispatch<React.SetStateAction<ChecklistData>>;
}

const BasicChecks: React.FC<Props> = ({ checklistData, setChecklistData }) => {
    const update = (key: keyof ChecklistData, val: string) => setChecklistData((prev) => ({ ...prev, [key]: val }));

    return (
        <Stack tokens={{ childrenGap: 15 }}>
            <ComboBox
                label={IvicosStrings.webRTCDiagnosticsBrowserLabel}
                options={browsers}
                selectedKey={checklistData.browser}
                onChange={(_, option) => option && update('browser', option.key as string)}
                styles={{ root: { width: 200 } }}
            />

            <ComboBox
                label={IvicosStrings.webRTCDiagnosticsBrowserUpdatedLabel}
                options={[
                    { key: IvicosStrings.yesAction, text: IvicosStrings.yesAction },
                    { key: IvicosStrings.noAction, text: IvicosStrings.noAction },
                    { key: IvicosStrings.webRTCDiagnosticsBrowserUpdatedUnknown, text: IvicosStrings.webRTCDiagnosticsBrowserUpdatedUnknown }
                ]}
                selectedKey={checklistData.browserUpdated}
                onChange={(_, option) => option && update('browserUpdated', option.key as string)}
                useComboBoxAsMenuWidth
                styles={{ root: { width: 200 } }}
            />

            {checklistData.browserUpdated === IvicosStrings.noAction && (
                <Stack style={{ width: '20%' }}>
                    <LabeledTextField
                        label={IvicosStrings.webRTCDiagnosticsBrowserVersionLabel}
                        value={checklistData.browserVersion || ''}
                        onChange={(val) => update('browserVersion', val)}
                        placeholder={IvicosStrings.webRTCDiagnosticsBrowserVersionPlaceholder}
                    />
                </Stack>
            )}

            <ComboBox
                label={IvicosStrings.webRTCDiagnosticsInternetConnectionLabel}
                options={[
                    { key: IvicosStrings.yesAction, text: IvicosStrings.yesAction },
                    {
                        key: IvicosStrings.webRTCDiagnosticsInternetConnectionLabelSometimes,
                        text: IvicosStrings.webRTCDiagnosticsInternetConnectionLabelSometimes
                    },
                    { key: IvicosStrings.noAction, text: IvicosStrings.noAction }
                ]}
                selectedKey={checklistData.internetConnection}
                onChange={(_, option) => option && update('internetConnection', option.key as string)}
                useComboBoxAsMenuWidth
                styles={{ root: { width: 200 } }}
            />

            <Link href="https://www.breitbandmessung.de/test" target="_blank">
                {IvicosStrings.webRTCDiagnosticsSpeedTestLabel}
            </Link>
            <Stack style={{ width: '60%', marginTop: -2 }}>
                <LabeledTextField
                    label={IvicosStrings.webRTCDiagnosticsSpeedTestResultLabel}
                    value={checklistData.speedTestResult || ''}
                    onChange={(val) => update('speedTestResult', val)}
                    multiline
                    rows={3}
                />
            </Stack>

            <ComboBox
                label={IvicosStrings.webRTCDiagnosticsMicrophoneLabel}
                options={yesNo}
                selectedKey={checklistData.microphoneWorking}
                onChange={(_, option) => option && update('microphoneWorking', option.key as string)}
                useComboBoxAsMenuWidth
                styles={{ root: { width: 200 } }}
            />

            <ComboBox
                label={IvicosStrings.webRTCDiagnosticsCameraLabel}
                options={yesNo}
                selectedKey={checklistData.cameraWorking}
                onChange={(_, option) => option && update('cameraWorking', option.key as string)}
                useComboBoxAsMenuWidth
                styles={{ root: { width: 200 } }}
            />

            <ComboBox
                label={IvicosStrings.webRTCDiagnosticsPermissionsLabel}
                options={yesNo}
                selectedKey={checklistData.permissionsGranted}
                onChange={(_, option) => option && update('permissionsGranted', option.key as string)}
                useComboBoxAsMenuWidth
                styles={{ root: { width: 200 } }}
            />
        </Stack>
    );
};

export default BasicChecks;
